import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

/**
 * Read the allow_negative_stock setting via RPC
 * (bypasses PostgREST schema cache issues with new columns)
 */
export function useAllowNegativeStock(restaurantId: string) {
  return useQuery({
    queryKey: ['allow-negative-stock', restaurantId],
    queryFn: async (): Promise<boolean> => {
      const { data, error } = await supabase.rpc('get_allow_negative_stock' as any, {
        p_restaurant_id: restaurantId,
      });

      if (error) {
        console.error('Error fetching allow_negative_stock:', error);
        return false;
      }

      return data ?? false;
    },
    enabled: !!restaurantId,
    staleTime: 5 * 60 * 1000,
  });
}

/**
 * Update the allow_negative_stock setting via RPC
 */
export function useUpdateAllowNegativeStock(restaurantId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (allowNegativeStock: boolean) => {
      const { error } = await supabase.rpc('update_allow_negative_stock' as any, {
        p_restaurant_id: restaurantId,
        p_allow_negative_stock: allowNegativeStock,
      });

      if (error) {
        throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['allow-negative-stock', restaurantId] });
    },
  });
}
